import { useState } from 'react';
import { callApiHooked } from '../callApiHooked';

export const useSubmit = (url, body) => {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  async function handleSubmit() {
    setLoading(true);
    setError(null);
    setData(null);
    await callApiHooked(
      url,
      'PUT',
      {},
      body,
      (res) => {
        setData(res);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      },
    );
  }
  return {
    handleSubmit,
    data,
    loading,
    error,
  };
};
